import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { quantityUnitNameConfig } from './QuantityUnit.name';

enum QuantityUnit {
  piece = '10',
  unit = '11',
  house = '12',
  setting = '13',
}

const quantityUnitMap = new Map([
  ['10', QuantityUnit.piece],
  ['11', QuantityUnit.unit],
  ['12', QuantityUnit.house],
  ['13', QuantityUnit.setting],
]);

const rawValueToQuantityUnit = rawValueToEnumWithDefault(quantityUnitMap, '');

const quantityUnitToDisplay = enumToNameWithDefault(QuantityUnit, quantityUnitNameConfig);

const quantityUnitToDisplayWithPrefix = enumToNameWithDefault(QuantityUnit, quantityUnitNameConfig, true);

export { QuantityUnit, quantityUnitToDisplay, quantityUnitToDisplayWithPrefix, rawValueToQuantityUnit };
